<template>
  <dialog
   class="custom-component"
   :class="`${size} ${center ? 'center' : ''}`"
   id="dialog"
   ref="dialog"
  >
    <modal-title
      :title="title"
      @close="closeModal"
    ></modal-title>
    <div class="card-body">
      <slot></slot>
    </div>
    <modal-buttons 
      v-if="!hideModalButtons"
      @save="$emit('submit')"
      @cancel="closeModal"
      :submitButtonText="submitButtonText"
      :disableButtons="disableButtons"
      :loading="loading"
    ></modal-buttons>
  </dialog>
</template>

<script>
import ModalButtons from '@/components/ModalButtons';
import ModalTitle from '@/components/ModalTitle';
import ModalMixin from '@/mixins/ModalMixin';
import dialogPolyfill from 'dialog-polyfill';

export default {
  name: 'dialog-component',
  mixins: [ModalMixin],
  mounted() {
    this.$nextTick(function onMounted() {
      dialogPolyfill.registerDialog(this.$refs.dialog);
      this.$refs.dialog.showModal();
      document.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
          // Esc
          this.closeModal();
        }
      });
    });
  },
  methods: {
    closeModal() {
      if (this.customClose) {
        this.customClose();
      } else {
        this.close();
      }
    },
  },
  beforeUnmount() {
    this.$refs.dialog.close();
    document.removeEventListener('keyup', this.closeModal);
  },
  components: {
    ModalButtons,
    ModalTitle,
  },
  props: {
    size: {
      type: String,
      default: 'medium',
      validate: size => ['small', 'medium', 'large', 'extra-large'].includes(size),
    },
    center: Boolean,
    title: String,
    customClose: Function,
    submitButtonText: String,
    hideModalButtons: {
      type: Boolean,
      default: false,
    },
    disableButtons: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
dialog {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
  width: 600px;
  max-width: 90vw;
  top: 20px;
  padding: 0;
  position: relative;
}
dialog.small { width: 350px }

dialog.medium { width: 600px }

dialog.large { width: 900px }

dialog.extra-large { width: 1200px }

dialog.center { margin: 0 auto; top: 50%; transform: translateY(-50%); }

dialog::backdrop,
dialog + .backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000 !important;
}
.label-bold {
  font-weight: 500;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog.vue